import { useQuery } from "@tanstack/react-query"

import { getUserOnboarding } from "data/fetch/epl/epl"

import {
  setDoNotRetryOn404,
  setRetryLimit,
  setStaleTimeInMinutes,
} from "../helpers"
import { queries } from "../keys"

export const useEplUserOnboardingQuery = (userId, enabled = true) =>
  useQuery({
    queryKey: queries.epl.onboarding(userId).queryKey,
    queryFn: () => getUserOnboarding(userId),
    staleTime: setStaleTimeInMinutes(2),
    enabled,
    retry: (failureCount, error) =>
      setDoNotRetryOn404(error) && setRetryLimit(failureCount, 5),
  })

export default {
  useEplUserOnboardingQuery,
}
